module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-BdCn20.92d685f7.otf";